import { Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";

import { MyAccountModel } from "../../models/MyAccount";
import { FeatureAccess } from "../../models/Master";
import { UserContext, UserContextType } from "../components/AppContent";
import { hasAccess } from "../../utils";
export interface PropsFromState {
  loggedInUser: MyAccountModel;
  masterFeatureAccessState: FeatureAccess[] | null;
  children: any;
  featureId: number;
}

type AllProps = PropsFromState;
export const RequireAuth: React.FC<AllProps> = ({
  masterFeatureAccessState,
  children,
  featureId,
}) => {
  const { roleId } = useContext<UserContextType>(UserContext);
  const location = useLocation();
  const isAuthenticated = hasAccess(
    roleId,
    masterFeatureAccessState,
    featureId
  );

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};
